import { render, staticRenderFns } from "./SpecificationMaterialTable.vue?vue&type=template&id=5b9d6d63"
import script from "./SpecificationMaterialTable.vue?vue&type=script&lang=js"
export * from "./SpecificationMaterialTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports